module.exports = __webpack_public_path__ + "static/media/project-icon-todo.6efaf86a.png";